<template>
  <ModalCashRegister v-if="modalShowCashRegister" @closeModal="closeModal" @submitCashRegister="submitCashRegister"
    :label="isOpen ? 'Saldo Akhir' : 'Saldo Awal'" />
  <div class="bg-white dark:bg-dark-900 overflow-hidden rounded-lg shadow-lg">
    <!-- Header Section with Status -->
    <div class="relative p-6 border-b border-gray-100 dark:border-dark-800">
      <div class="flex justify-between items-center">
        <div>
          <h2 class="text-3xl font-bold text-gray-800 dark:text-gray-200">
            Cash Register
          </h2>
          <p class="text-base text-gray-500 dark:text-gray-400 mt-1">
            Current Session Status
          </p>
        </div>
        <div class="flex flex-col items-end">
          <div class="text-2xl font-bold text-gray-700 dark:text-gray-200">
            {{ stopwatch }}
          </div>
          <div class="mt-2 px-4 py-1.5 rounded-full text-sm font-semibold" :class="isOpen
            ? 'bg-green-100 text-green-700 dark:bg-green-900 dark:text-green-300'
            : 'bg-red-100 text-red-700 dark:bg-red-900 dark:text-red-300'
            ">
            {{ isOpen ? "OPEN" : "CLOSED" }}
          </div>
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="px-6 pb-6">
      <div v-if="!isOpen" class="text-center">
        <ExclamationCircleIcon class="h-20 w-20 text-gray-200 dark:text-gray-800 mx-auto" />
        <span class="text-gray-400 dark:text-gray-600">Cash Register Masih Belum Dimulai</span>
      </div>
      <!-- Saldo Section -->
      <div v-if="isOpen && isDetail" class="grid grid-cols-1 gap-6">
        <!-- Desktop View -->
        <div class="hidden sm:grid sm:grid-cols-2 lg:grid-cols-1 gap-6">
          <div class="p-4 bg-gray-100 dark:bg-dark-700 rounded-lg lg:col-span-1">
            <dt class="text-base font-medium text-gray-500 dark:text-gray-400">
              Saldo Awal
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-gray-900 dark:text-gray-200">
              {{
                formatRupiah(
                  initialBalance == undefined || initialBalance == null
                    ? 0
                    : initialBalance
                )
              }}
            </dd>
          </div>
          <div class="p-4 bg-gray-100 dark:bg-dark-700 rounded-lg lg:col-span-1">
            <dt class="text-base font-medium text-gray-500 dark:text-gray-400">
              Total Transaksi
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-gray-900 dark:text-gray-200">
              {{ formatRupiah(totalTransaction) }}
            </dd>
          </div>
          <div class="p-4 bg-gray-100 dark:bg-dark-700 rounded-lg">
            <dt class="text-base font-medium text-gray-500 dark:text-gray-400">
              Total Transaksi (Closed)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-gray-900 dark:text-gray-200">
              {{ formatRupiah(totalClosedTransaction) }}
            </dd>
          </div>
          <div class="p-4 bg-gray-100 dark:bg-dark-700 rounded-lg">
            <dt class="text-base font-medium text-gray-500 dark:text-gray-400">
              Jumlah Transaksi (Closed)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-gray-900 dark:text-gray-200">
              {{ countClosedTransaction }}
            </dd>
          </div>
          <div class="p-4 bg-gray-100 dark:bg-dark-700 rounded-lg">
            <dt class="text-base font-medium text-gray-500 dark:text-gray-400">
              Total Transaksi (Pending)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-gray-900 dark:text-gray-200">
              {{ formatRupiah(totalPendingTransaction) }}
            </dd>
          </div>
          <div class="p-4 bg-gray-100 dark:bg-dark-700 rounded-lg">
            <dt class="text-base font-medium text-gray-500 dark:text-gray-400">
              Jumlah Transaksi (Pending)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-gray-900 dark:text-gray-200">
              {{ countPendingTransaction }}
            </dd>
          </div>
          <div class="p-4 bg-gray-100 dark:bg-dark-700 rounded-lg">
            <dt class="text-base font-medium text-gray-500 dark:text-gray-400">
              Jumlah Kas Kecil (Deposit)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-gray-900 dark:text-gray-200">
              {{ formatRupiah(totalDepositPettyCash) }}
            </dd>
          </div>
          <div class="p-4 bg-gray-100 dark:bg-dark-700 rounded-lg">
            <dt class="text-base font-medium text-gray-500 dark:text-gray-400">
              Jumlah Kas Kecil (Withdrawal)
            </dt>
            <dd class="mt-2 text-2xl font-semibold text-gray-900 dark:text-gray-200">
              {{ formatRupiah(totalWithdrawalPettyCash) }}
            </dd>
          </div>
        </div>

        <!-- Mobile View with Accordion -->
        <div class="sm:hidden space-y-4">
          <BaseAccordion>
            <template #header>
              <div>
                <dt class="text-sm font-medium text-gray-500 dark:text-gray-400">
                  Jumlah Transaksi (closed)
                </dt>
                <dd class="text-lg font-semibold text-gray-900 dark:text-gray-200 text-left">
                  {{ countClosedTransaction }}
                </dd>
              </div>
            </template>
            <template #content>
              <div class="space-y-4">
                <div class="flex flex-col items-start">
                  <span class="text-base font-medium text-gray-500 dark:text-gray-400">Saldo Awal</span>
                  <span class="text-lg font-semibold text-gray-900 dark:text-gray-200">{{
                    formatRupiah(
                      initialBalance == undefined || initialBalance == null
                        ? 0
                        : initialBalance
                    )
                  }}</span>
                </div>
                <div>
                  <dt class="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Total Transaksi
                  </dt>
                  <dd class="text-lg font-semibold text-gray-900 dark:text-gray-200">
                    {{ formatRupiah(totalTransaction) }}
                  </dd>
                </div>
                <div class="flex flex-col items-start">
                  <span class="text-base font-medium text-gray-500 dark:text-gray-400">Transaksi Selesai</span>
                  <span class="text-lg font-semibold text-gray-900 dark:text-gray-200">{{
                    formatRupiah(totalClosedTransaction) }}</span>
                </div>
                <div class="flex flex-col items-start">
                  <span class="text-base font-medium text-gray-500 dark:text-gray-400">Transaksi Pending</span>
                  <span class="text-lg font-semibold text-gray-900 dark:text-gray-200">{{
                    formatRupiah(totalPendingTransaction) }}</span>
                </div>
                <div>
                  <dt class="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Jumlah Transaksi
                  </dt>
                  <dd class="text-lg font-semibold text-gray-900 dark:text-gray-200">
                    {{ countPendingTransaction }}
                  </dd>
                </div>
                <div>
                  <dt class="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Jumlah Kas Kecil (Deposit)
                  </dt>
                  <dd class="text-lg font-semibold text-gray-900 dark:text-gray-200">
                    {{ formatRupiah(totalDepositPettyCash) }}
                  </dd>
                </div>
                <div>
                  <dt class="text-sm font-medium text-gray-500 dark:text-gray-400">
                    Jumlah Kas Kecil (Withdrawal)
                  </dt>
                  <dd class="text-lg font-semibold text-gray-900 dark:text-gray-200">
                    {{ formatRupiah(totalWithdrawalPettyCash) }}
                  </dd>
                </div>
              </div>
            </template>
          </BaseAccordion>
        </div>
      </div>

      <!-- Footer Section -->
      <div class="mt-8 flex flex-col sm:flex-row justify-between sm:items-center gap-2">
        <button
          class="metallic-gold-bg text-dark-800 px-4 py-3 text-base font-semibold rounded-lg shadow-md hover:opacity-90 transition-opacity duration-300 flex items-center gap-2 dark:text-dark-800 whitespace-nowrap"
          :disabled="!isOpen" :class="{ 'opacity-50 cursor-not-allowed': !isOpen }" @click="createNewTransaction">
          <ShoppingCartIcon class="h-5 w-5" />
          New Transaction
        </button>

        <!-- Action Button -->
        <button v-if="!isOpen"
          class="bg-green-500 text-white px-4 py-3 text-base font-semibold rounded-lg shadow-md hover:bg-green-600 transition duration-300 flex items-center gap-2  whitespace-nowrap"
          @click="showModal">
          <ArrowRightOnRectangleIcon class="h-6 w-6" />
          Open Register
        </button>
        <button v-if="isOpen"
          class="bg-red-500 text-white px-4 py-3 text-base font-semibold rounded-lg shadow-md hover:bg-red-600 transition duration-300 flex items-center gap-2  whitespace-nowrap"
          @click="showModal">
          <ArrowLeftOnRectangleIcon class="h-6 w-6" />
          Close
        </button>
      </div>
    </div>
  </div>
</template>

<script>
  import { formatRupiah } from "@/helpers/formatRupiah";
  import ModalCashRegister from "./modals/ModalCashRegister.vue";
  import { mapActions, mapGetters } from "vuex";
  import {
    ArrowRightOnRectangleIcon,
    ArrowLeftOnRectangleIcon,
    ShoppingCartIcon,
  } from "@heroicons/vue/24/solid";
  import { ExclamationCircleIcon } from "@heroicons/vue/24/outline";
  import BaseAccordion from "@/components/base/BaseAccordion.vue";
  import axios from "axios";
  import print from "@/helpers/print";
  import { calculateCashRegisterSummary } from "@/helpers/cashRegisterCalculations";

  export default {
    name: "CashRegister",
    components: {
      ModalCashRegister,
      ArrowRightOnRectangleIcon,
      ArrowLeftOnRectangleIcon,
      ShoppingCartIcon,
      ExclamationCircleIcon,
      BaseAccordion,
    },
    data() {
      return {
        modalShowCashRegister: false,
        isBlur: false,
        stopwatch: "00:00:00",
        elapsed: "00:00:00",
        startTime: null,
        // isOpen: false,
        // initialBalance: 0, // Example initial balance
        // endBalance: 0,
        difference: 0,
        // totalTransaction: 0,
        allCashRegisters: [],
        summaryCashRegister: {},
      };
    },
    computed: {
      // ...mapGetters('cash_registers', ['allCashRegisters']),
      ...mapGetters("sales_orders", ["allSalesOrders"]),
      ...mapGetters("petty_cash", ["allPettyCashes"]),
      ...mapGetters('item_categories', ['allItemCategories']),
      ...mapGetters('tables', ['allTables']),
      ...mapGetters('payment_methods', ['allPaymentMethods']),
      ...mapGetters("settings", ["allSettings"]),
      ...mapGetters("global_discounts", ["allGlobalDiscounts"]),
      relevantCashRegister() {
        return this.allCashRegisters.find((cr) => cr.status == "open");
      },
      isDetail() {
        const isAllowed = ["1", "2"];
        return localStorage.getItem("role_id") == "null" || isAllowed.includes(localStorage.getItem("role_id"));
      },
      totalDepositPettyCash() {
        console.log(this.allPettyCashes);
        return this.allPettyCashes.reduce((sum, pc) => sum + (this.relevantCashRegister.id == pc.cash_register_id && pc.amount_deposit ? parseFloat(pc.amount_deposit) : 0), 0);
      },
      totalWithdrawalPettyCash() {
        return this.allPettyCashes.reduce((sum, pc) => sum + (this.relevantCashRegister.id == pc.cash_register_id && pc.amount_withdrawal ? parseFloat(pc.amount_withdrawal) : 0), 0);
      },
      initialBalance() {
        return this.relevantCashRegister?.start_saldo;
      },
      endBalance() {
        return this.relevantCashRegister?.end_saldo;
      },
      isOpen() {
        return (
          this.relevantCashRegister != null &&
          this.relevantCashRegister != undefined
        );
      },
      totalTransaction() {
        const salesOrders = this.allSalesOrders.filter((so) => so.cash_register_id == this.relevantCashRegister.id);
        return salesOrders.reduce((sum, item) => {
          const grandTotal = parseFloat(item.grand_total);
          let addition =
            grandTotal == undefined || grandTotal == null ? 0 : grandTotal;
          return sum + addition;
        }, 0);
      },
      totalClosedTransaction() {
        return this.allSalesOrders
          .filter((so) => so.status == "paid" && so.cash_register_id == this.relevantCashRegister.id)
          .reduce((sum, item) => {
            const grandTotal = parseFloat(item.grand_total);
            let addition =
              grandTotal == undefined || grandTotal == null ? 0 : grandTotal;
            return sum + addition;
          }, 0);
      },
      countClosedTransaction() {
        return this.allSalesOrders.filter((so) => so.status == "paid" && so.cash_register_id == this.relevantCashRegister.id).length;
      },
      totalPendingTransaction() {
        return this.allSalesOrders
          .filter((so) => so.status == "pending" && so.cash_register_id == this.relevantCashRegister.id)
          .reduce((sum, item) => {
            const grandTotal = parseFloat(item.grand_total);
            let addition =
              grandTotal == undefined || grandTotal == null ? 0 : grandTotal;
            return sum + addition;
          }, 0);
      },
      countPendingTransaction() {
        return this.allSalesOrders.filter((so) => so.status == "pending" && so.cash_register_id == this.relevantCashRegister.id).length;
      },
    },
    async created() {
      await this.refreshCashRegister();
      await this.$store.dispatch('item_categories/fetchItemCategories', { limit: 1000 });
      await this.$store.dispatch('tables/fetchTables', { limit: 1000 });
      await this.$store.dispatch('payment_methods/fetchPaymentMethods', { limit: 1000 });
      await this.$store.dispatch("settings/fetchSettings", { limit: 1000 });
      await this.$store.dispatch("global_discounts/fetchGlobalDiscounts", { limit: 1000 });
      await this.$store.dispatch('sales_orders/fetchSalesOrders', { limit: 1000 });
    },
    methods: {
      ...mapActions("cash_registers", [
        "createCashRegister",
        "closeCashRegister",
      ]),
      ...mapActions("petty_cash", ["fetchPettyCashes"]),
      formatRupiah,
      formatDate(date) {
        console.log(date);
        if (!date) return "-";
        const d = new Date(date);
        const pad = (num) => num.toString().padStart(2, "0");

        const day = pad(d.getDate());
        const month = pad(d.getMonth() + 1);
        const year = d.getFullYear().toString().slice(-2);
        const hours = pad(d.getHours());
        const minutes = pad(d.getMinutes());
        const seconds = pad(d.getSeconds());
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
      },
      formatCurrency(value) {
        return new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
        }).format(value);
      },
      startStopwatch() {
        let seconds = this.isOpen
          ? Math.floor(
            (new Date() - new Date(this.relevantCashRegister.time_start)) / 1000
          )
          : 0;
        this.timeInterval = setInterval(() => {
          seconds++;
          const hrs = String(Math.floor(seconds / 3600)).padStart(2, "0");
          const mins = String(Math.floor((seconds % 3600) / 60)).padStart(2, "0");
          const secs = String(seconds % 60).padStart(2, "0");
          this.stopwatch = `${hrs}:${mins}:${secs}`;

          // Update Elapsed Time
          if (this.isOpen) {
            this.elapsed = `${hrs}:${mins}:${secs}`;
          }
        }, 1000);
      },
      stopStopwatch() {
        clearInterval(this.timeInterval);
        this.stopwatch = "00:00:00";
      },
      showModal() {
        this.modalShowCashRegister = true;
        this.isBlur = true;
      },
      closeModal() {
        setTimeout(() => {
          this.modalShowCashRegister = false;
          this.isBlur = false;
        }, 200);
      },
      submitCashRegister(saldo) {
        // this.isOpen = !this.isOpen;
        try {
          if (!this.isOpen) {
            this.startCashRegister(saldo);
          } else {
            console.log("stop");
            this.stopCashRegister(saldo);
          }
          this.closeModal();
        } catch (error) {
          console.log(error);

          this.emit("show-dialog", error.response.data.message);
          this.$toast.add({
            severity: "error",
            summary: "Failed",
            detail: error.response.data.message,
            life: 5000,
          });
        }
      },
      async refreshCashRegister() {
        this.allCashRegisters = [];
        try {
          this.stopStopwatch();
          await this.fetchPettyCashes();
          const response = await this.$store.dispatch(
            "cash_registers/fetchOpenCashRegisters"
          );
          if (response) {
            this.allCashRegisters = response.data;
          }
          if (this.isOpen) {
            this.startStopwatch();
          }
        } catch (error) {
          console.log(error);
          this.allCashRegisters = [];

          this.$toast.add({
            severity: "error",
            summary: "Failed",
            detail: error.response.data.message,
            life: 5000,
          });
        }
      },
      async startCashRegister(saldo) {
        try {
          this.initialBalance = parseInt(saldo);

          await this.createCashRegister({
            // start_by: DataTypes.INTEGER,
            // end_by: DataTypes.INTEGER,
            start_saldo: saldo,
            // end_saldo: DataTypes.DECIMAL(10, 2),
            time_start: new Date(),
            // time_end: DataTypes.DATE,
            status: "open",
          });

          this.refreshCashRegister();
        } catch (error) {
          console.log(error);

          this.$emit("show-dialog", error.response.data.message);
          this.$toast.add({
            severity: "error",
            summary: "Failed",
            detail: error.response.data.message,
            life: 5000,
          });
        }
      },
      async stopCashRegister(saldo) {
        try {
          this.endBalance = parseInt(saldo);

          await this.closeCashRegister({
            id: this.relevantCashRegister.id,
            // start_by: DataTypes.INTEGER,
            // end_by: DataTypes.INTEGER,
            // start_saldo: saldo,
            end_saldo: saldo,
            // time_start: new Date(),
            time_end: new Date(),
            status: "close",
          });

          await this.printReport();

          this.refreshCashRegister();
        } catch (error) {
          console.log(error);

          this.$emit("show-dialog", error.response.data.message);
          this.$toast.add({
            severity: "error",
            summary: "Failed",
            detail: error.response.data.message,
            life: 5000,
          });
        }
      },
      createNewTransaction() {
        this.$router.push({ name: "newTransaction" });
      },
      emit: ["show-dialog"],
      async setSummaryCashRegister() {
        try {
          const { data } = await this.$store.dispatch("reports/fetchCashRegisterReport", {
            cash_register_id: this.relevantCashRegister.id,
          });

          const settings = this.allSettings.length > 0 ? this.allSettings[0] : {};

          this.summaryCashRegister = calculateCashRegisterSummary(
            data,
            this.allPaymentMethods,
            this.allItemCategories,
            this.allTables,
            settings,
            this.allGlobalDiscounts
          );
        } catch (error) {
          console.log(error);
        }
      },
      formatElementForPrinting(data) {
        let printText = "";
        const rows = [];

        // Add company header with center alignment
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push(process.env.VUE_APP_STORE_NAME);
        rows.push(process.env.VUE_APP_STORE_ADDRESS);
        rows.push(process.env.VUE_APP_STORE_PHONE);
        rows.push(print.breakLine(40, "-"));

        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push("LAPORAN PENJUALAN HARIAN");
        rows.push(print.breakLine(40, " "));

        // Add transaction details
        rows.push(
          print.twoColumn(`Work Date:`, `${this.formatDate(data.time_start)} - ${this.formatDate(data.time_end)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(
            `Item Sales:`,
            `${this.formatRupiah(data.revenue_item)}`,
            17, 6, 17
          )
        );
        rows.push(
          print.twoColumn(`Item Discount:`, `${data.item_discount > 0 ? '-' : ''}${this.formatRupiah(data.item_discount)}`, 17, 6, 17)
        );
        rows.push(
          print.alignText(`-------------`, "", 40, 'right')
        );
        rows.push(
          print.twoColumn(`Item Net Sales:`, `${this.formatRupiah(data.revenue_sales)}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Bill Discount:`, `${data.bill_discount > 0 ? '-' : ''}${this.formatRupiah(data.bill_discount)}`, 17, 6, 17)
        );
        rows.push(
          print.alignText(`-------------`, "", 40, 'right')
        );
        rows.push(
          print.twoColumn(`Total Sales:`, `${this.formatRupiah(data.total_sales)}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Total Service Charge:`, `${this.formatRupiah(data.total_service_charge)}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Total Tax:`, `${this.formatRupiah(data.total_tax)}`, 17, 6, 17)
        );
        rows.push(
          print.alignText(`-------------`, "", 40, 'center')
        );
        rows.push(
          print.twoColumn(`Gross Sales:`, `${this.formatRupiah(data.revenue_net_sales)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(`Total # of Item:`, `${data.total_item}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Total # of of Bills:`, `${data.total_bill}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Sales per Bill:`, `${this.formatRupiah(data.revenue_sales_per_bill)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(`Total # of of Guests:`, `${data.total_bill}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Sales per Guest:`, `${this.formatRupiah(data.revenue_sales_per_bill)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(`Sales w/o SC:`, `${this.formatRupiah(data.revenue_sales_without_service_charge)}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Sales w/o Tax:`, `${this.formatRupiah(data.revenue_sales_without_tax)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(`Cancel With Order:`, `${data.total_qty_cancel_item}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Total Amount:`, `${this.formatRupiah(data.revenue_cancel_item)}`, 17, 6, 17)
        );

        rows.push(print.breakLine(40, " "));
        rows.push(
          print.twoColumn(`Void # Payment:`, `${data.total_qty_void_sales}`, 17, 6, 17)
        );
        rows.push(
          print.twoColumn(`Void Amount:`, `${this.formatRupiah(data.revenue_void_sales)}`, 17, 6, 17)
        );

        // rows.push(print.breakLine(40, " "));
        // rows.push(`Jam Cetak: \t ${new Date().toLocaleString()}`);
        // rows.push("\n\n\n"); // Extra lines for paper cut
        // rows.push(print.breakLine(40, " "));
        // rows.push(print.breakLine(40, "="));
        // rows.push("\x1b\x61\x01"); // Center alignment
        // rows.push("Suspicious Transaction");
        // rows.push("\x1b\x61\x00"); // Left alignment
        // rows.push(print.breakLine(40, "="));

        // data?.sales_order_code?.forEach((code) => {
        //   rows.push(print.oneLine(code, 40));
        // });
        // rows.push(print.breakLine(40, "="));
        // rows.push(print.breakLine(40, " "));

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Sales By Type");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_type?.forEach((type) => {
          rows.push(print.oneLine(`${type?.type}:`, 40));
          rows.push(print.twoColumn(`   QTY (${parseFloat(type?.qty / data?.total_item * 100).toFixed(2)}%) :`, `${type?.qty}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Item Sales (${parseFloat(type?.revenue_item / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(type?.revenue_item)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Discount Item :`, `${data.item_discount > 0 ? '-' : ''}${this.formatRupiah(type?.item_discount)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Discount Bill :`, `${data.bill_discount > 0 ? '-' : ''}${this.formatRupiah(type?.bill_discount)}`, 17, 6, 17));
          rows.push(print.oneLine(`------------------`, 40, `right`));
          rows.push(print.twoColumn(`  Item Net Sales (${parseFloat(type?.revenue_net_sales / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(type?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_type)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Sales By Category");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_category_item?.forEach((category) => {
          rows.push(print.oneLine(`${category?.category_name}:`, 40));
          rows.push(print.twoColumn(`   QTY (${parseFloat(category?.qty / data?.total_item * 100).toFixed(2)}%) :`, `${category?.qty}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Item Sales (${parseFloat(category?.revenue_item / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(category?.revenue_item)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Discount (${parseFloat(category?.bill_discount / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${data.bill_discount > 0 ? '-' : ''}${this.formatRupiah(category?.bill_discount)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Item Net Sales (${parseFloat(category?.revenue_net_sales / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(category?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_category_item)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Sales By Global Discount");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_global_discount?.forEach((discount) => {
          rows.push(print.oneLine(`${discount?.type}:`, 40));
          rows.push(print.twoColumn(`   QTY (${parseFloat(discount?.qty / data?.total_item * 100).toFixed(2)}%) :`, `${discount?.qty}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Item Sales (${parseFloat(discount?.revenue_item / data?.revenue_net_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(discount?.revenue_item)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Discount Item :`, `${data.item_discount > 0 ? '-' : ''}${this.formatRupiah(discount?.item_discount)}`, 17, 6, 17));
          rows.push(print.twoColumn(`  Discount Bill :`, `${data.bill_discount > 0 ? '-' : ''}${this.formatRupiah(discount?.bill_discount)}`, 17, 6, 17));
          rows.push(print.oneLine(`------------------`, 40, `right`));
          rows.push(print.twoColumn(`  Item Net Sales (${parseFloat(discount?.revenue_net_sales / data?.revenue_sales * 100).toFixed(2)}%) :`, `${this.formatRupiah(discount?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_global_discount)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Sales By Table/Room");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_table?.forEach((table) => {
          rows.push(print.twoColumn(`${table?.table_name}:`, `${this.formatRupiah(table?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_table)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Payment Type Summary");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_payment_type?.filter((paymentType) => paymentType?.payment_method_name !== "Complimentary").forEach((paymentType) => {
          rows.push(print.twoColumn(`${paymentType?.payment_method_name}:`, `${this.formatRupiah(paymentType?.revenue_net_sales)}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${this.formatRupiah(data?.total_sales_by_payment_type)}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        rows.push(print.breakLine(40, " "));

        const complimentary = data?.sales_by_payment_type?.find((type) => type?.payment_method_name === "Complimentary");

        if (complimentary) {
          rows.push(print.breakLine(40, "="));
          rows.push(print.twoColumn(`Complimentary:`, `${this.formatRupiah(complimentary?.revenue_net_sales)}`, 17, 6, 17));
          rows.push(print.breakLine(40, "="));
        }

        rows.push(print.breakLine(40, "="));
        rows.push("\x1b\x61\x01"); // Center alignment
        rows.push("Pax By Table/Room Summary");
        rows.push("\x1b\x61\x00"); // Left alignment
        rows.push(print.breakLine(40, "="));

        data?.sales_by_table?.forEach((table) => {
          rows.push(print.twoColumn(`${table?.table_name}:`, `${table?.pax}`, 17, 6, 17));
        });
        rows.push(print.breakLine(40, " "));
        rows.push(print.breakLine(40, "-"));
        rows.push(print.twoColumn(`Total:`, `${data?.total_pax_by_floor}`, 17, 6, 17));
        rows.push(print.breakLine(40, "="));

        // Join all rows with newlines
        printText = rows.join("\n");

        return printText;
      },
      async printReport() {
        try {
          await this.setSummaryCashRegister();
          // Convert the element to text format suitable for ESC/POS
          const printText = this.formatElementForPrinting(this.summaryCashRegister);
          console.log("printText:", printText);

          // Send to backend printer endpoints
          const print_url =
            process.env.VUE_APP_ROOT_API + "/printer/printing/custom-print";

          const response = await axios.post(print_url, {
            text: printText,
            printer_ip: process.env.VUE_APP_CASIER_IP,
          });

          // Optional: Show success message
          console.log("Print job sent successfully", response);
        } catch (error) {
          console.error("Print error:", error);
          this.errorMessage = "Failed to print: " + error.message;
          this.showErrorDialog = true;
        }
      },
    },
  };
</script>

<style>
  body {
    font-family: "Inter", sans-serif;
  }
</style>
